import { TokenType } from "@/config/token-types";

export const getApeBonus = (token) => {
  const tokenType = token.type;
  if (tokenType === TokenType.GENESIS) {
    const breedingsLeft = token.breedingsLeft;
    if (breedingsLeft === 0) return 5;
    if (breedingsLeft === 1 || breedingsLeft === 2) return 10;
    if (breedingsLeft === 3) return 20;
    return 10;
  }
  return 0;
};
